export const isDateValid = (value?: Date | string | null): boolean => {
	const date = value && new Date(value);
	return !!date && !isNaN(date.getTime()) && date.getFullYear() > 1900 && date.getFullYear() < new Date().getFullYear() + 100;
};
